import { eachDayOfInterval, format, startOfDay } from "date-fns";

import type { DateFilter } from "../../../components/DatePeriodSelector/types";
import { DateSelectionMode } from "../../../components/DatePeriodSelector/types";

/**
 * Returns all dates in the overview date filter range as "yyyy-MM-dd" (local timezone).
 * dateTs and startTs are local-midnight timestamps (ms); output matches API response_date format.
 * For period mode, range is from startTs through today (inclusive), so today is always shown.
 */
export function getDateRangeFromOverviewFilter(
  filter: DateFilter
): string[] {
  if (filter.type === DateSelectionMode.Date) {
    return [format(new Date(filter.dateTs), "yyyy-MM-dd")];
  }
  const start = startOfDay(new Date(filter.startTs));
  const end = startOfDay(new Date());
  const dates = eachDayOfInterval({ start, end });
  return dates.map((d) => format(d, "yyyy-MM-dd"));
}
